import React from 'react';
import { ordersApi, brokersApi } from '@/services/api';
import BaseCalculatedOrders, { OrderSide } from '../orders/BaseCalculatedOrders';

interface EtfCalculatedOrdersProps {
    onOrdersSubmitted: () => void;
}

const EtfCalculatedOrders: React.FC<EtfCalculatedOrdersProps> = ({ onOrdersSubmitted }) => {
    return (
        <BaseCalculatedOrders
            titlePrefix="ETF"
            supportsClientWiseEdit={true}
            onOrdersSubmitted={onOrdersSubmitted}
            fetchBuyOrders={() =>
                ordersApi.getCalculatedEtfBuyOrders({ page_size: 500 }).then(res => ({
                    aggregatedOrders: res.aggregated_non_nri ?? [],
                    clientOrders: res.calculated_orders,
                }))
            }
            fetchSellOrders={() =>
                ordersApi.getCalculatedEtfSellOrders({ page_size: 500 }).then(res => ({
                    aggregatedOrders: res.aggregated_non_nri ?? [],
                    clientOrders: res.calculated_orders,
                }))
            }
            bulkAssignBroker={(side: OrderSide, orderIds: number[], brokerId: number | null) =>
                brokersApi.bulkAssignEtfBroker(side, orderIds, brokerId)
            }
            fetchBrokersByScheme={(schemeId) => brokersApi.getBrokersByScheme(schemeId)}
            submitOrders={(side: OrderSide, orderIds: number[], emailRecipients?: string[]) => {
                const submitFn = side === 'buy' ? ordersApi.submitCalculatedEtfBuyOrders : ordersApi.submitCalculatedEtfSellOrders;
                return submitFn({
                    order_ids: orderIds,
                    ...(emailRecipients && emailRecipients.length > 0 ? { email_recipients: emailRecipients } : {})
                });
            }}
            updateClientOrderQuantities={(side: OrderSide, updates) =>
                ordersApi.bulkUpdateEtfCalculatedOrderQuantities(side, updates)
            }
            getAmountLabel={(side: OrderSide) => side === 'sell' ? 'Redeem Amount' : 'Amount'}
        />
    );
};

export default EtfCalculatedOrders;